import { backendApi } from "./axios";
import { EXAM_RESULT_ENDPOINTS, TUTOR_CLASS_ENDPOINTS, TUTOR_ENDPOINTS, TUTOR_NOTE_ENDPOINTS } from "./endpoints";

export function updateProfile(payload) {
  return backendApi.put(TUTOR_ENDPOINTS.PROFILE_UPDATE, payload);
}

export function getLimits() {
  return backendApi.get(TUTOR_ENDPOINTS.GET_LIMITS);
}

export function publicProfile(tutorId) {
  return backendApi.get(TUTOR_ENDPOINTS.PUBLIC_PROFILE.replace(':tutorId', tutorId));
}

export function getProfile() {
  return backendApi.get(TUTOR_ENDPOINTS.GET_PROFILE);
}

export function updateEmail(data) {
  return backendApi.put(TUTOR_ENDPOINTS.UPDATE_EMAIL, data);
}

export function sendTutorInvitation(email) {
  return backendApi.post(TUTOR_ENDPOINTS.INVITE.replace(':email', encodeURIComponent(email.trim())));
}

export function getAvailability(tutorId) {
  return backendApi.get(TUTOR_ENDPOINTS.GET_AVAILABILITY.replace(':tutorId', tutorId));
}

export function addAvailability(payload) {
  return backendApi.post(TUTOR_ENDPOINTS.ADD_AVAILABILITY, payload);
}

export function removeAvailability(slotId) {
  return backendApi.delete(TUTOR_ENDPOINTS.REMOVE_AVAILABILITY.replace(':slotId', slotId));
}

export function fetchRequests() {
  return backendApi.get(TUTOR_CLASS_ENDPOINTS.REQUESTS);
}

export function createScheduledClassRequest(payload) {
  return backendApi.post(TUTOR_CLASS_ENDPOINTS.CREATE_SCHEDULED_CLASS, payload);
}

export function fetchClassRequest(classId) {
  return backendApi.get(TUTOR_CLASS_ENDPOINTS.GET_REQUEST.replace(':classId', classId));
}

export function rejectRequest(classId) {
  return backendApi.put(TUTOR_CLASS_ENDPOINTS.REJECT_REQUEST.replace(':classId', classId));
}

export function toggleVerificationCallStatus(classId) {
  return backendApi.put(TUTOR_CLASS_ENDPOINTS.VERIFICATION_CALL_STATUS.replace(':classId', classId));
}

export function scheduleClass(classId, payload) {
  return backendApi.put(TUTOR_CLASS_ENDPOINTS.SCHEDULE_CLASS.replace(':classId', classId), payload);
}

export function fetchSchedules() {
  return backendApi.get(TUTOR_CLASS_ENDPOINTS.FETCH_SCHEDULES);
}

export function fetchPublicProfiles(payload) {
  return backendApi.get(TUTOR_ENDPOINTS.TUTORS_PROFILES, { params: payload });
}

export function fetchEnrolledStudents() {
  return backendApi.get(TUTOR_CLASS_ENDPOINTS.ENROLLED_STUDENTS);
}

export function sendVerificationEmail(classId, payload) {
  return backendApi.post(TUTOR_CLASS_ENDPOINTS.SEND_VERIFICATION_CALL.replace(':classId', classId), payload);
}

export function deleteClasses(studentId) {
  return backendApi.delete(TUTOR_CLASS_ENDPOINTS.END_CLASSES.replace(':studentId', studentId));
}

export function classesByStudent(studentId) {
  return backendApi.get(TUTOR_CLASS_ENDPOINTS.END_CLASSES.replace(':studentId', studentId));
}

export function previousClassesByStudent(studentId) {
  return backendApi.get(TUTOR_CLASS_ENDPOINTS.STUDENT_PAST_CLASSES.replace(':studentId', studentId));
}

export function fetchClassInstanceDetails(classInstanceId) {
  return backendApi.get(TUTOR_CLASS_ENDPOINTS.CLASS_INSTANCE_DETAILS.replace(':classInstanceId', classInstanceId));
}

export function cancelClassInstance(instanceId, payload = {}) {
  return backendApi.patch(
    TUTOR_CLASS_ENDPOINTS.CANCEL_CLASS_INSTANCE.replace(':instanceId', instanceId),
    payload
  );
}

export function getRescheduleRequestDetails(requestId) {
  return backendApi.get(TUTOR_CLASS_ENDPOINTS.RESCHEDULE_REQUEST_DETAILS.replace(':requestId', requestId));
}

export function acceptRescheduleRequest(requestId,payload) {
  return backendApi.put(TUTOR_CLASS_ENDPOINTS.ACCEPT_RESCHEDULE_REQUEST.replace(':requestId', requestId), payload);
}

export function rejectRescheduleRequest(requestId) {
  return backendApi.put(TUTOR_CLASS_ENDPOINTS.REJECT_RESCHEDULE_REQUEST.replace(':requestId', requestId));
}

export function createRescheduleRequest(payload) {
  return backendApi.post(TUTOR_CLASS_ENDPOINTS.CREATE_RESCHEDULE_REQUEST, payload);
}

export function createNote(payload) {
  return backendApi.post(TUTOR_NOTE_ENDPOINTS.CREATE, payload);
}

export function listNotes() {
  return backendApi.get(TUTOR_NOTE_ENDPOINTS.LIST);
}

export function listPublishedNotes(tutorId) {
  return backendApi.get(TUTOR_NOTE_ENDPOINTS.PUBLISHED.replace(":tutorId", tutorId));
}

export function deleteNotice(noticeId) {
  return backendApi.delete(TUTOR_NOTE_ENDPOINTS.DELETE.replace(':noticeId', noticeId));
}

export function updateNotice(noticeId, payload) {
  return backendApi.put(TUTOR_NOTE_ENDPOINTS.UPDATE.replace(':noticeId', noticeId), payload);
}

export function checkNoteLimit() {
  return backendApi.get(TUTOR_NOTE_ENDPOINTS.CHECK_LIMIT);
}

export function getStudentReviews(tutorId, page = 1, limit = 10) {
  return backendApi.get(TUTOR_CLASS_ENDPOINTS.GET_STUDENT_REVIEWS.replace(":tutorId", tutorId), {
    params: { page, limit }
  });
}

export function createResult(studentId, payload) {
  return backendApi.post(EXAM_RESULT_ENDPOINTS.CREATE.replace(':studentId', studentId), payload);
}

export function updateResult(resultId, payload) {
  return backendApi.put(EXAM_RESULT_ENDPOINTS.UPDATE.replace(':resultId', resultId), payload);
}

export function deleteResult(resultId) {
  return backendApi.delete(EXAM_RESULT_ENDPOINTS.DELETE.replace(':resultId', resultId));
}

export function getStudentResults(studentId) {
  return backendApi.get(EXAM_RESULT_ENDPOINTS.GET_ALL_BY_STUDENT.replace(':studentId', studentId));
}
export function publicClassSchedule(tutorId) {
  return backendApi.get(TUTOR_CLASS_ENDPOINTS.PUBLIC_CLASS_SCHEDULE.replace(":tutorId", tutorId));
}

export function connectGoogleCalendar(keycloakId) {
  return backendApi.get(TUTOR_ENDPOINTS.CONNECT_CALENDAR.replace(":keycloakId", keycloakId));
}

export function getUnconfirmedClasses() {
  return backendApi.get(TUTOR_CLASS_ENDPOINTS.UNCONFIRMED_CLASSES);
}

export function updateClassConfirmationForPayment(session) {
  return backendApi.patch(TUTOR_CLASS_ENDPOINTS.CONFIRM_CLASS.replace(':instanceId', session));
}

export function getBankInfo() {
  return backendApi.get(TUTOR_ENDPOINTS.GET_BANK_INFO);
}

export function updateBankInfo(payload) {
  return backendApi.put(TUTOR_ENDPOINTS.UPDATE_BANK_INFO, payload);
}

export function resetGoogleCalendarConnection(keycloakId) {
  return backendApi.post(TUTOR_ENDPOINTS.RESET_CALENDAR_CONNECTION.replace(":keycloakId", keycloakId));
}

export function preDeleteCheck() {
  return backendApi.get(TUTOR_ENDPOINTS.PRE_DELETE_CHECK);
}

export function deleteAccount(payload) {
  return backendApi.post(TUTOR_ENDPOINTS.DELETE_ACCOUNT, payload);
}